import AlertWrapper from './AlertWrapper.vue';

export default AlertWrapper;
